import React from 'react';
import PropTypes from 'prop-types';
import ReactLoading from 'react-loading';

/**
 * Composant LayoutLoader - Indicateur de chargement pour Layout
 *
 * @component
 * @param {Object} props - Props du composant
 * @param {string} props.type - Type de loader (défaut: "bubbles")
 * @param {string} props.color - Couleur du loader (défaut: "#0074c2")
 * @param {string} props.className - Classe CSS additionnelle
 * @returns {JSX.Element} Composant rendu
 */
const LayoutLoader = ({
  type = 'bubbles',
  color = '#0074c2',
  className = '',
  ...props
}) => {
  return (
    <div className={className} {...props}>
      <ReactLoading type={type} color={color} />
      <div>Loading...</div>
    </div>
  );
};

// PropTypes
LayoutLoader.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default LayoutLoader;
